import { clientEnv } from '@/config/env/client';

export const DAVINCI_CDN = clientEnv.NEXT_PUBLIC_DAVINCI_ASSETS_CDN || 'https://cdn.davinci.care';
